import React from 'react';
import useToggleClass from '../hooks/useToggleClass';
import Icons from './Icons';

interface ILoadingProps {
  size?: 'small' | 'medium' | 'large';
}

export default function LoadingSpinner(props: ILoadingProps) {
  const loaderRef = React.useRef<any>();

  const { addClass } = useToggleClass();
  const { size } = props;

  const getClassNameFor = (size: string) => {
    const classes = new Map();

    classes.set('small', 'loader-sm');
    classes.set('medium', 'loader-md');
    classes.set('large', 'loader-lg');

    return classes.get(size);
  };

  React.useEffect(() => {
    if (size) addClass(getClassNameFor(size), loaderRef);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [size]);

  return (
    <div className="loading-circle-wrapper" ref={loaderRef}>
      <div className="loading-circle">
        <Icons.Loading />
      </div>
    </div>
  );
}
